































import { Component, Vue, Prop } from 'vue-property-decorator'
import { jobDetailsLocalisationKeys } from '@/features/job/job.localisation'
import { IProcessingErrors } from '@/features/job/store'
import { JOB_LIST_NAME } from '@/features/job/job.router'
import { JOB_STATUSES } from '@/constants'

@Component
export default class JobDetailsStatusBar extends Vue {
  private progress: number = 1
  private translations = jobDetailsLocalisationKeys
  private jobStatuses = JOB_STATUSES

  @Prop()
  readonly processingErrorsCount!: number

  @Prop()
  readonly status!: JOB_STATUSES

  @Prop({ default: '' })
  readonly jobFileName!: string

  private handleClose () {
    this.$router.push({ name: JOB_LIST_NAME })
  }

  private getColor () {
    if (this.status === JOB_STATUSES.FAILED) return 'negative'
    return this.processingErrorsCount ? 'warning' : 'positive'
  }
}
